import React from 'react';
import { motion } from 'framer-motion';
export function TrustBadges() {
  return <section className="py-8 px-4 bg-white" data-id="element-199">
      <div className="max-w-[420px] mx-auto space-y-6" data-id="element-200">
        {/* Secure Payment Box */}
        <motion.fieldset initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3
      }} className="border border-black/20 rounded-xl p-4 bg-transparent" data-id="element-201">
          <legend className="px-3 text-black/60 text-sm flex items-center gap-2 mx-auto bg-white" data-id="element-202">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-203">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2" data-id="element-204"></rect>
              <path d="M7 11V7a5 5 0 0 1 10 0v4" data-id="element-205"></path>
            </svg>
            Pago seguro garantizado
          </legend>
          <div className="flex justify-center items-center gap-6 pt-2" data-id="element-206">
            {/* VISA */}
            <span className="text-2xl font-black italic tracking-tight" style={{
            color: '#1434CB',
            letterSpacing: '-1px'
          }} data-id="element-207">
              VISA
            </span>

            {/* Mastercard */}
            <div className="flex flex-col items-center" data-id="element-208">
              <svg viewBox="0 0 32 20" width="32" height="20" data-id="element-209">
                <circle cx="11" cy="10" r="10" fill="#EB001B" data-id="element-210" />
                <circle cx="21" cy="10" r="10" fill="#F79E1B" opacity="0.9" data-id="element-211" />
              </svg>
              <span className="text-[8px] text-black mt-0.5" data-id="element-212">mastercard</span>
            </div>

            {/* PayPal */}
            <span className="text-xl font-black italic" data-id="element-213">
              <span style={{
              color: '#003087'
            }} data-id="element-214">
                Pay
              </span>
              <span style={{
              color: '#0079C1'
            }} data-id="element-215">
                Pal
              </span>
            </span>
          </div>
        </motion.fieldset>

        {/* MercadoLíder Platinum Box */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        delay: 0.1
      }} className="bg-white rounded-xl p-5 shadow-md border border-black/10" data-id="element-216">
          {/* Header */}
          <div className="flex items-start gap-3 mb-4" data-id="element-217">
            <div className="flex items-center justify-center mt-0.5" data-id="element-218">
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#00a650" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-219">
                <path d="M12 2l3.09 3.09L19.36 6l-.82 4.18L22 13.09l-3.27 2.55L18 20l-4.18-.82L10.73 22l-2.55-3.27L4 18l.82-4.18L2 10.91l3.27-2.55L6 4l4.18.82L13.09 2z" data-id="element-220"></path>
                <path d="M9 12l2 2 4-4" stroke="#00a650" data-id="element-221"></path>
              </svg>
            </div>
            <div data-id="element-222">
              <h3 className="text-xl font-bold leading-tight" style={{
              color: '#00a650'
            }} data-id="element-223">
                MercadoLíder Platinum
              </h3>
              <p className="text-black/50 text-sm mt-0.5" data-id="element-224">
                ¡Uno de los mejores del sitio!
              </p>
            </div>
          </div>

          {/* Progress Bar */}
          <div className="flex h-1.5 gap-1 mb-5" data-id="element-225">
            <span className="flex-1 rounded-full" style={{
            backgroundColor: '#fce6e6'
          }} data-id="element-226"></span>
            <span className="flex-1 rounded-full" style={{
            backgroundColor: '#ffecd4'
          }} data-id="element-227"></span>
            <span className="flex-1 rounded-full" style={{
            backgroundColor: '#fff8cc'
          }} data-id="element-228"></span>
            <span className="flex-1 rounded-full" style={{
            backgroundColor: '#e6f9e6'
          }} data-id="element-229"></span>
            <span className="flex-1 rounded-full" style={{
            backgroundColor: '#39b54a'
          }} data-id="element-230"></span>
          </div>

          {/* Stats */}
          <div className="flex justify-between text-center" data-id="element-231">
            <div className="flex flex-col items-center flex-1" data-id="element-232">
              <span className="text-black font-bold text-base mb-0.5" data-id="element-233">
                +10mil
              </span>
              <span className="text-black/50 text-xs" data-id="element-234">Ventas</span>
            </div>
            <div className="flex flex-col items-center flex-1" data-id="element-235">
              <div className="h-6 flex items-center mb-0.5" data-id="element-236">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#999" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-237">
                  <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" data-id="element-238"></path>
                  <path d="M15 10l-4 4-2-2" stroke="#00a650" strokeWidth="2" data-id="element-239"></path>
                </svg>
              </div>
              <span className="text-black/50 text-xs" data-id="element-240">Buena atención</span>
            </div>
            <div className="flex flex-col items-center flex-1" data-id="element-241">
              <div className="h-6 flex items-center mb-0.5" data-id="element-242">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#999" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-243">
                  <circle cx="12" cy="12" r="10" data-id="element-244"></circle>
                  <path d="M12 6v6l2 1" data-id="element-245"></path>
                  <circle cx="18" cy="18" r="5" fill="#fff" stroke="#fff" data-id="element-246"></circle>
                  <path d="M16 18l1.5 1.5 2.5-2.5" stroke="#00a650" strokeWidth="2" data-id="element-247"></path>
                </svg>
              </div>
              <span className="text-black/50 text-xs" data-id="element-248">Entrega a tiempo</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}